import { call, put, takeLatest, takeEvery } from 'redux-saga/effects'
import {fetchContent} from "../api"
import {
    OPEN_SHOP_THE_LOOK_DIALOG,
    FETCH_SHOP_THE_LOOK_PRODUCTS_SUCCESS,
    FETCH_SHOP_THE_LOOK_PRODUCTS_ERROR
} from "../actions"

import { 
    FETCH_PRODUCTS_SUCCESSFUL, 
    FETCH_PRODUCTS_ERROR, 
    FETCH_PRODUCTS_REQUEST 
} from "../actions"

import get from 'lodash/get'

//TODO: REFACTOR THIS, Merge the products into one list and remove the shop dialog actions

function* fetchProducts(action) {
    try {
        var items = get(action, ['payload', 'items', 'shopItems']);
        if (!items) items = get(action, ['payload', 'shopItems']);

        if(!items) {
            yield put({ type: FETCH_PRODUCTS_SUCCESSFUL, payload: { id: action.payload.id, products: [] } });
            return;
        }
        const skus = items.map(item => item.sku).filter(x => x).join(',');
        if(!skus) {
            yield put({ type: FETCH_PRODUCTS_SUCCESSFUL, payload: { id: action.payload.id, products: [] } });
            return;
        }
        const products = yield call(fetchContent, `/products?skus=${skus}`);
        yield put({ type: FETCH_PRODUCTS_SUCCESSFUL, payload: { id: action.payload.id, products: products } });
    } catch (e) {
        yield put({ type: FETCH_PRODUCTS_ERROR, payload: { id: action.payload.id, message: e.message } } );
    }
}

function* fetchShopTheLookProducts(action) {
    try {
        var items = get(action, ['payload', 'items', 'shopItems']);
        if (!items) items = get(action, ['payload', 'shopItems']);

        if (!items) {
            yield put({ type: FETCH_SHOP_THE_LOOK_PRODUCTS_SUCCESS, payload: { id: action.payload.id, products: [] } });
            return;
        }
        const skus = items.map(item => item.sku).filter(x => x).join(',');
        if (!skus) {
            yield put({ type: FETCH_SHOP_THE_LOOK_PRODUCTS_SUCCESS, payload: { id: action.payload.id, products: [] } });
            return;
        }
        const products = yield call(fetchContent, `/products?skus=${skus}`);
        yield put({ type: FETCH_SHOP_THE_LOOK_PRODUCTS_SUCCESS, payload: { id: action.payload.id, products: products } });
    } catch (e) {
        yield put({ type: FETCH_SHOP_THE_LOOK_PRODUCTS_ERROR, payload: { id: action.payload.id, message: e.message } });
    }
}


function* fetchProductsSaga() {
    yield takeLatest(OPEN_SHOP_THE_LOOK_DIALOG, fetchShopTheLookProducts);
    yield takeEvery(FETCH_PRODUCTS_REQUEST, fetchProducts);
}

export default fetchProductsSaga;


// WEBPACK FOOTER //
// ./src/sagas/products.js